<div class="bn-notice-content" *ngIf="isPaymentSuccess">
    <div class="bn-notice-content">
        <app-bn-success-notice 
            [title]="'Successful payment'"
            [message]="'Please allow us up to 2 business days to process your payment and update your account.'"
        ></app-bn-success-notice>
    </div>
</div>
<div class="bn-notice-content" *ngIf="isPaymentFails">
    <div class="bn-notice-content">
        <app-bn-imp-notice [isPaymentFAils]="isPaymentFails" [isInvalidRouting]="isInvalidRouting"></app-bn-imp-notice>
    </div>
</div>
<div class="bn-confirm-sec margin-bottom mb32">
    <div class="bn-review-payment">
        <ng-container *ngIf="isPaymentSuccess; else reviewPayment">
            <div class="bn-confirm-title">Summary</div>
        </ng-container>
        <ng-template #reviewPayment>
            <div class="bn-confirm-title">Review payment</div>
            <div>
                <mapfre-button additionalClasses="link-button red-link float-right no-border no-padding no-margin waves-effect bn-cofirm-edit"
                (click)="goBackPaymentComponent()">
                <div class="font-weight-500 margin-right mr4 bn-confirm-edit">{{ 'EDIT' | translate }}</div>
                <ng-cotainer *ngIf="isAcmic; else maEdit">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M14.4525 3.70859L7.86879 10.4482L7.68474 11.7376L8.96565 11.5544L15.5518 4.81231C15.6978 4.66623 15.7799 4.46815 15.7799 4.26157C15.7799 4.05499 15.6979 3.85687 15.5518 3.7108C15.4057 3.56473 15.2076 3.48267 15.001 3.48267C14.7955 3.48267 14.5983 3.5639 14.4525 3.70859ZM13.5664 2.82692C13.9469 2.44642 14.4629 2.23267 15.001 2.23267C15.5391 2.23267 16.0552 2.44642 16.4357 2.82692C16.8162 3.20741 17.0299 3.72347 17.0299 4.26157C17.0299 4.79833 16.8172 5.31316 16.4385 5.69338L9.71144 12.5798C9.61522 12.6783 9.48917 12.7422 9.35286 12.7617L7.03675 13.0931C6.842 13.1209 6.6455 13.0555 6.50637 12.9164C6.36724 12.7773 6.30171 12.5808 6.32951 12.386L6.66021 10.0693C6.67897 9.93789 6.73909 9.81585 6.83185 9.72089L13.5664 2.82692Z"
                            fill="#005095" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M3.5873 6.2911C3.50483 6.2911 3.42575 6.32386 3.36744 6.38217C3.30913 6.44048 3.27637 6.51956 3.27637 6.60203V15.9613C3.27637 16.0438 3.30913 16.1229 3.36744 16.1812C3.42575 16.2395 3.50483 16.2723 3.5873 16.2723H12.9336C13.016 16.2723 13.0951 16.2395 13.1534 16.1812C13.2117 16.1229 13.2445 16.0438 13.2445 15.9613V11.2817C13.2445 10.9365 13.5243 10.6567 13.8695 10.6567C14.2147 10.6567 14.4945 10.9365 14.4945 11.2817V15.9613C14.4945 16.3753 14.33 16.7723 14.0373 17.0651C13.7446 17.3578 13.3476 17.5223 12.9336 17.5223H3.5873C3.17331 17.5223 2.77628 17.3578 2.48355 17.0651C2.19082 16.7723 2.02637 16.3753 2.02637 15.9613V6.60203C2.02637 6.18804 2.19082 5.79101 2.48355 5.49828C2.77628 5.20555 3.17331 5.0411 3.5873 5.0411H8.26694C8.61212 5.0411 8.89194 5.32092 8.89194 5.6661C8.89194 6.01127 8.61212 6.2911 8.26694 6.2911H3.5873Z"
                            fill="#005095" />
                    </svg>
                </ng-cotainer>
                <ng-template #maEdit>
                    <img src="./assets/img/images/icon-edit-red.svg" width="16" height="16" alt="edit icon" />
                </ng-template>
                </mapfre-button>
            </div>  
        </ng-template>
    </div>
    <hr class="thin-hr margin-top mt8 bn-confirm-title-hr" [ngClass]="{'margin-bottom mb32': isPaymentSuccess || isAcmic}">
    <div class="bn-confirm-paydata">
        <div class="bn-confirm-card-l">
            <div>
                <div class="bn-title-text  margin-bottom mb4" [ngClass]="{'lh-20':!isAcmic,'lh-24-imp mb8':isAcmic}">Account holder’s name</div>
                <div class="bn-title-val lh-24-imp margin-bottom mb16" [ngClass]="{'mb24':isAcmic}">{{billing?.bankAccount?.accountHolderName | titlecase}}</div>
            </div>
            <div>
                <div class="bn-title-text margin-bottom mb4" [ngClass]="{'lh-20':!isAcmic,'lh-24-imp mb8':isAcmic}">Bank routing number</div>
                <div class="bn-title-val lh-24-imp margin-bottom mb16" [ngClass]="{'mb24':isAcmic}">{{billing?.bankAccount?.routingNumber.digits}}</div>
            </div>
            <div>
                <div class="bn-title-text  margin-bottom mb4" [ngClass]="{'lh-20':!isAcmic,'lh-24-imp mb8':isAcmic}">Bank account number</div>
                <div class="bn-title-val lh-24-imp margin-bottom mb16" [ngClass]="{'mb24':isAcmic}">{{billing?.bankAccount?.accountNumber.digits | maskAccountNumber}}</div>
            </div>
            <div>
                <div class="bn-title-text margin-bottom mb4" [ngClass]="{'lh-20':!isAcmic,'lh-24-imp mb8':isAcmic}">Check number (optional)</div>
                <div class="bn-title-val lh-24-imp margin-bottom mb0">
                    <ng-container *ngIf="billing?.checkNumber === ''">
                        N/A
                    </ng-container>
                    <ng-container *ngIf="billing?.checkNumber !== '' ">
                        {{billing?.checkNumber}}
                    </ng-container>
                </div>
            </div>
    
        </div>
        <div class="bn-confirm-card-r">
            <div class="bn-secondary-title margin-bottom mb4" [ngClass]="{'mb8':isAcmic}">Payment amount</div>
            <div class="bn-secondary-amt">{{billing?.paymentAmount | currency }}</div>
        </div>
    </div>
    <ng-container *ngIf="!isPaymentSuccess">
    <hr class="thin-hr">
    <div>
        <div class="margin-bottom mb24 default-checkbox-label">
            <input type="checkbox" class="single-checkbox" id="store-checkbox-for-confirm" (change)="authorizePayment($event)"/>
            <label class="margin-left ml16 no-margin-bottom bn-store-label" for="store-checkbox-for-confirm">
                
            </label>
            <div class="bn-read-more-sec">
            <div class="bn-read-more-main">
                <ng-container *ngIf="!isAcmic else acmicData">
                    I authorize Mapfre U.S.A. Corp.
                    and its subsidiaries ("Mapfre”) to initiate the scheduled single entry deduction from the bank account
                    identified above for payment of premium and any associated fees on the above identified insurance policy issued
                    by Mapfre (the “Policy”).
                </ng-container>
                <ng-template #acmicData>
                    I authorize Auto Club Mapfre Insurance Company (“ACMIC”) to initiate the scheduled single entry
                     deduction from the bank account identified above for payment of premium and any associated fees
                      on the above identified insurance policy issued by ACMIC (the “Policy”); and to initiate
                       credit entries to the account to correct any erroneous deductions.
                </ng-template>
                
                </div>
                <div *ngIf="readMore" class="bn-read-more-sub">
                    <ng-container *ngIf="!isAcmic; else acmicReadmore">
                        To initiate credit entries to the account to correct any erroneous deductions. I understand that a fee may apply and
                        be added to this withdrawal where permitted by law; and that a fee will be charged if payment is returned. I
                        understand that my authorization for this transaction does not authorize Mapfre to make any future deductions from
                        my account for the Policy without my consent. This single entry authorization will remain in effect until: (1) the
                        payment is processed and the account is debited; or (2) Mapfre receives written notice from me of its termination,
                        in such time and manner as to afford Mapfre a reasonable opportunity to act on it. *Mapfre U.S.A. Corp. and its
                        subsidiaries, American Commerce Insurance Company (Columbus, OH); Citation Insurance Company (Webster, MA); The
                        Commerce Insurance Company (Webster, MA); Commerce West Insurance Company (San Ramon, CA); and Mapfre Insurance
                        Company (Florham Park, NJ).
                    </ng-container>
                    <ng-template #acmicReadmore>
                        I understand that a fee may apply and be added to this withdrawal where permitted by law; and that a fee will be charged if payment is returned. I understand that my authorization for this transaction does not authorize ACMIC to make any future deductions from my account for the Policy without my consent. This single entry authorization will remain in effect until: (1) the payment is processed and the account is debited; or (2) ACMIC receives written notice from me of its termination, in such time and manner as to afford ACMIC a reasonable opportunity to act on it.
                    </ng-template>
                </div>
                <div *ngIf="!readMore" class="bn-read-more-btn cursor-pointer" (click)="readMoreText(true)">Read more</div>
                <div *ngIf="readMore" class="bn-read-more-btn cursor-pointer" (click)="readMoreText(false)">Close</div>
            </div>
        </div>
    </div>
    <hr class="thin-hr bn-confirm-hr-2" [ngClass]="{'margin-vertical mv32':isAcmic}">
    <div class="col">
        <div class="row bn-payment-action-sec">
    
            <div class="">
    
                <mapfre-button [disabledValue]="!loader" [inputType]="'submit'" [translateValue]="'CANCEL' | translate"
                    additionalClasses="ghost secondary bn-confirm-payment-action-btn mr-3"
                    (click)='goBackPaymentComponent()'
                    >
                    {{ 'CANCEL' | translate }}
                </mapfre-button>
            </div>
            <div class="">
                <mapfre-button 
                    [ngClass]="{'custom_loader':loader}"
                    [disabledValue]="!loader && isCheckboxChecked"
                    [translateValue]="'CONFIRM_PAYMENT' | translate"
                    [inputType]="'submit'"
                    additionalClasses="basic primary bn-cancel-payment-action-btn no-margin" (click)='sendPayment("N")'>
                    {{ 'CONFIRM_PAYMENT' | translate}}
                </mapfre-button>
            </div>
        </div>
    </div>
</ng-container>
</div>

<ng-container *ngIf="modalForMultiplePayment">
    <mapfre-modal 
     [modalOptions]="paymentModal"
     (hideModalOutput)="resetHideModal()"
     (click)="resetHideModal()">
     <div class="modal-body no-margin-top margin-bottom mb8">
       <hr class="no-margin-bottom no-margin-top thin-hr" />
       
       <div class="margin-top mt24 text-center">
         <div>
           <svg-information-icon-svg></svg-information-icon-svg>
         </div>
         <div class="info-consideration margin-top mt16">
           {{ 'For your consideration' }}
         </div>
        <div class="margin-top mt24 info-consideration-message">{{ 'An online payment has already been accepted for this policy today. Please confirm you want to make this additional payment' }}</div> 
       </div>
       <div class="text-center margin-bottom mb16 margin-top mt24">
         <mapfre-button
             (click)="sendPayment('Y')"
             [ngClass]="{ custom_loader: loader }"
             [disabledValue]="!loader"
             additionalClasses="basic primary medium-btn h40 w240 mx-auto margin-bottom mb24" 
           > {{ 'CONFIRM_PAYMENT' | translate }}
         </mapfre-button>
           <mapfre-button
             (click)="onClickBack()"
             additionalClasses="ghost secondary small-btn h32 no-padding mx-auto" 
           >{{ 'CANCEL' | translate }}
         </mapfre-button>
       </div>
     </div>
   </mapfre-modal>
 </ng-container>